import { computed } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';

/**
 * Composable for accessing authentication state and user roles.
 */
export function useAuth() {
  const { user, isAuthenticated, isLoading, logout } = useAuth0();

  // Roles are stored in the Auth0 token under a custom claim.
  const roles = computed<string[]>(() => {
    const userRoles = user.value?.['https://manta.vet/roles'];
    return Array.isArray(userRoles) ? userRoles : [];
  });

  const isAdmin = computed(
    () => roles.value.includes('admin') || roles.value.includes('superadmin'),
  );

  return {
    user,
    isAuthenticated,
    isLoading,
    roles,
    isAdmin,
    logout,
  };
}
